// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bg81d3f8 {\n  background: #81d3f8!important;\n}\n.bg8bcd98 {\n  background: #8bcd98!important;\n}\n", ""]);
// Exports
module.exports = exports;
